var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.89,
    height: 18.89,
    viewBox: "0 0 18.89 18.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add",
    transform: "translate(-6.75 -6.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9066",
    "data-name": "Path 9066",
    d: "M18,7.875v16.64",
    transform: "translate(-1.805)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9067",
    "data-name": "Path 9067",
    d: "M24.515,18H7.875",
    transform: "translate(0 -1.805)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.c7ac5eb0fd03da888b4595527341d93a.svg";
export { ForwardRef as ReactComponent };